import React from "react";
import B2bBanner from "../../../assets/popupBanners/B2bBanner1.png";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import QuickLinks from "../../../components/basic/QuickLinks";
import Sponsors from "../../../components/basic/Sponsors";
import Layout from "../../../components/Layouts/Layouts/Layout";
import Layout2 from "../../../components/Layouts/Layouts/Layout2";
import { getAuthUserlocal } from "../../../store/services";
import '../b2b/b2b.css';
import CollaborationReqTrack from "./b2b/CollaborationReqTrack";
import UsesReqTrack from "./b2b/UsersReqTrack";

const B2bVirtualForumNew = () => {
    return (
        <Layout>
            <Layout2>
                <DashboardHeader />
                <img
                    src={B2bBanner}
                    alt="Virtual B2B Forum"
                    className="img-fluid w-100 h-50"
                />
                <hr className='my-2' />
                <div>
                    <div>
                        {getAuthUserlocal().selectMembership !== 'Collaboration' ? (
                            <UsesReqTrack />
                        ) : (
                            <CollaborationReqTrack />
                        )}
                    </div>
                </div>

                <div className="my-2">
                    {getAuthUserlocal().reqType === 'collaborationReq' || getAuthUserlocal().reqType === 'B2BInterest' ? <Sponsors /> : <QuickLinks />}
                </div>
            </Layout2>
        </Layout>
    );
};

export default B2bVirtualForumNew;